// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangeName_wrapper__ssP5x","buttonContainer":"ChangeName_buttonContainer__72dOD"};